import sukoon1 from "../../img/new/amanDhattarwalEvent.jpg";
import sukoon2 from "../../img/new/25.jpeg";
import sukoon3 from "../../img/new/3.JPG";

import xpression1 from "../../img/new/5.JPG";
import xpression2 from "../../img/new/2.JPG";

import technocean1 from "../../img/new/13.jpg";
import technocean2 from "../../img/new/19.jpeg";
import technocean3 from "../../img/new/11.jpg";

import getPlaced1 from "../../img/new/6 (copy).jpg";
import getPlaced2 from "../../img/new/19.jpeg";

export const events = [
	{
		title: "YOUTHFEST-SUKOON",
		date: "",
		description:
			"An amalgam of cultural & technical fun carnival to fill your upcoming days with amusement. In this era where endless challenges give birth to depression and dark days, we, the Team OASIS wants to remind you that the hope you're trying to find outside comes from within. With this idea of #HopeToLive, we are launching a 15 days fest to boost your lives with a dose of great fun, enthusiasm & unlimited entertainment.",
		images: [sukoon1, sukoon2, sukoon3],
		videos: [
			"https://youtu.be/RpmOweBTyjc",
			"https://youtu.be/V_hBbb-bPRk",
			"https://youtu.be/wPRuVYEZYXk",
		],
	},
	{
		title: "TECHNOCEAN",
		date: "",
		description:
			" TechnOcean is biggest tech fest of LPU organised with our Respected Pro Vice Chancellor, Dr. Lovi Raj Gupta Sir and Respected Vice Chancellor, Dr. Preeti Bajaj Madam, along with our benevolent faculties Dr. Prateek Agrawal Sir and Mrs. Harjeet Kaur Ma'am.",
		images: [technocean1, technocean2, technocean3],
	},
	{
		title: "XPRESSION",
		date: "",
		description:
			"XPRESSIONS - Biggest media fest of LPU. School of Journalism, Film and Creative Arts, Organised by Student Organisation OASIS, under the aegis of Division of Youth Affairs, Student Welfare Wing.",
		images: [xpression1, xpression2],
	},
	{
		title: "GET PLACED",
		date: "",
		description:
			"GET PLACED - Introduction to the IT sector & corporate world by the placement experts Mr. Nishant Chahar(SDE Microsoft) and Mr. Subhesh Kumar (SDE Amazon,Berlin).",
		images: [getPlaced1, getPlaced2],
	},
];
